import * as React from 'react';

// @mui material components
import Grid from "@mui/material/Grid";
import MDInput from "../../../components/MDInput";
import PropTypes from "prop-types";
import { useFormContext } from "react-hook-form";

function MerchantBankDetails({ merchant, editmode, setMerchant, type }) {
  const { register, formState: { errors } } = useFormContext();

  return (
    <Grid mt={1} mb={1} padding={1}>
      <Grid container spacing={1.5}>
        <Grid item xs={12} sm={6} md={3}>
          <MDInput size="small" type="text" label="Bank Name" inputProps={{ maxLength: 100 }}
            {...register("bankName")} error={!!errors.bankName}
            helperText={errors.bankName?.message ?? ""} fullWidth disabled={!editmode} />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <MDInput size="small" type="text" label="Bank Account Number" inputProps={{ maxLength: 16 }}
            {...register("bankAccount")} error={!!errors.bankAccount}
            helperText={errors.bankAccount?.message ?? ""} fullWidth disabled={!editmode} />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <MDInput size="small" type="text" label="Bank IFSC Code" inputProps={{ maxLength: 15 }}
            {...register("ifscCode")} error={!!errors.ifscCode}
            helperText={errors.ifscCode?.message ?? ""} fullWidth disabled={!editmode} />
        </Grid>
      </Grid>
    </Grid>
  );
}

MerchantBankDetails.defaultProps = {
  merchant: false,
  editmode: false,
  setMerchant: false,
  type: 'update'
}

MerchantBankDetails.propTypes = {
  merchant: PropTypes.any,
  editmode: PropTypes.bool,
  setMerchant: PropTypes.func,
  type: PropTypes.string
}

export default MerchantBankDetails;

